import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

export type CrewHolidayKind = 'REGULAR' | 'SPECIAL_NON_WORKING';
export type CrewHolidayRecurrence =
  | 'FIXED_MONTH_DAY'
  | 'NTH_WEEKDAY_OF_MONTH'
  | 'EASTER_OFFSET'
  | 'LUNAR_NEW_YEAR'
  | 'EVERY_WEEKDAY';

export interface CrewHoliday {
  id: number;
  code: string;
  name: string;
  kind: CrewHolidayKind;
  countryCode: string;
  recurrence: CrewHolidayRecurrence;
  month?: number | null;
  dayOfMonth?: number | null;
  weekday?: number | null;
  weekOrdinal?: number | null;
  easterOffset?: number | null;
  isActive: boolean;
  sortOrder: number;
  notes?: string | null;
  ruleLabel?: string;
  resolvedDate?: string | null;
  resolvedYear?: number;
  createdAt: string;
  updatedAt: string;
}

export const useCrewHolidays = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<CrewHoliday> | CrewHoliday[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<CrewHoliday>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useCrewHoliday = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<CrewHoliday>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
